export function buildActivitySummary(
  selNaf = [],
  themes = [],
  codeLabels = {}
) {
  const codes = Array.isArray(selNaf) ? selNaf : [];
  const themesArr = Array.isArray(themes) ? themes : [];
  const codesSet = new Set(codes);

  const items = [];
  const covered = new Set();

  // 1) Sous-thèmes totalement couverts → "Macro • Sous-thème"
  themesArr.forEach(th => {
    (th.subthemes || []).forEach(st => {
      const list = Array.isArray(st.selections) ? st.selections : [];
      const allIn = list.length > 0 && list.every(c => codesSet.has(c));
      if (allIn) {
        list.forEach(c => covered.add(c));
        items.push({
          type: 'subtheme',
          key: `${th.key}/${st.key}`,
          label: `${th.label} • ${st.label}`,
          codes: list,
        });
      }
    });
  });

  // 2) Codes restants (manuels/partiels) → tag par code avec libellé
  codes.forEach(code => {
    if (!covered.has(code)) {
      let label = codeLabels[code] || code;
      if (label === code) {
        // tentative de fallback via sous-thèmes
        for (const th of themesArr) {
          const st = (th.subthemes || []).find(s =>
            (s.selections || []).includes(code)
          );
          if (st) {
            label = st.label;
            break;
          }
        }
      }
      items.push({ type: 'code', key: code, label, codes: [code] });
    }
  });

  return items;
}
